<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h1 class="text-primary">
            {{ $t("common.labels.manageTitle") }}
            {{ $t("common.labels.goodies") }}
          </h1>
          <div class="row">
            <stats
              url="/crud/goodie/stats"
              entity="goodies"
              :statsNeedsRefresh.sync="statsNeedsRefresh"
            ></stats>
          </div>
          <div class="text-right">
            <button
              class="btn btn-primary btn-simple"
              @click="createFunction()"
            >
              <i class="fa fa-plus"></i>
              {{ $t("common.labels.createNew") }}
              {{ $t("common.labels.goodie") }}
            </button>
          </div>
          <ajax-table
            class="table-hover table-striped"
            :columns="table.columns"
            :entity="'goodie'"
            :url="'/goodie'"
            :tableNeedsRefresh.sync="tableNeedsRefresh"
            :rows="table.data"
            :perPage="50"
            @edit="gotToEditPage"
            @view="gotToViewPage"
            @create="createFunction"
            @delete="deleteFunction"
            :options="{ actions: actions }"
          >
            <template slot="table-top-more-actions">
              <upload-button
                name="import"
                :options="{
                  upload: true,
                  targetUrl: 'goodie/import',
                  method: 'POST',
                  headers: {},
                  base64: false,
                  label: $t('common.buttons.import'),
                  class: 'btn btn-info btn-simple btn-block',
                }"
                @uploaded="importResponse"
              ></upload-button>
            </template>
          </ajax-table>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" role="dialog" id="goodieModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <form
            @submit.prevent="viewMode === 'create' ? createItem() : editItem()"
          >
            <div class="modal-header bg-primary text-white">
              <h3 class="modal-title mt-0">
                {{ $t("common.buttons.edit") }} {{ currentItem.title }}
              </h3>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" class="text-white">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <slot name="create-form">
                <div class="vue-form-generator goodie-form">
                  <fieldset>
                    <div
                      class="form-group valid col-md-12 field-input"
                      style="float: left"
                    >
                      <fg-input
                        type="text"
                        :label="$t('common.field.title')"
                        :placeholder="$t('common.field.title')"
                        :disabled="viewMode === 'view'"
                        v-model="currentItem.title"
                      ></fg-input>
                    </div>
                    <div
                      class="form-group valid col-md-12 field-textarea"
                      style="float: left"
                    >
                      <label>{{ $t("common.field.description") }}</label>
                      <textarea
                        type="textarea"
                        class="form-control"
                        :placeholder="$t('common.field.description')"
                        :disabled="viewMode === 'view'"
                        v-model="currentItem.description"
                      ></textarea>
                    </div>
                    <div
                      class="form-group valid col-md-6 field-textarea"
                      style="float: left"
                    >
                      <label>{{ $t("common.field.stage") }}</label>
                      <select
                        class="form-control"
                        :label="$t('common.field.stage')"
                        :placeholder="$t('common.field.stage')"
                        :disabled="viewMode === 'view'"
                        v-model="currentItem.stageId"
                      >
                        <option :value="null">---</option>
                        <option :value="1">Palier 1</option>
                        <option :value="2">Palier 2</option>
                        <option :value="3">Palier 3</option>
                        <option :value="4">Palier 4</option>
                      </select>
                    </div>
                    <template v-if="currentItem.stageId === 4">
                      <div
                        class="form-group valid col-md-6 field-input"
                        style="float: left"
                      >
                        <fg-input
                          type="number"
                          :label="$t('common.field.quantity')"
                          :placeholder="$t('common.field.quantity')"
                          :disabled="viewMode === 'view'"
                          v-model="currentItem.quantity"
                        ></fg-input>
                      </div>
                      <div
                        class="form-group valid col-md-6 field-textarea"
                        style="float: left"
                      >
                        <label>{{ $t("common.field.month") }}</label>
                        <select
                          class="form-control"
                          :label="$t('common.field.month')"
                          :placeholder="$t('common.field.month')"
                          :disabled="viewMode === 'view'"
                          v-model="currentItem.month"
                        >
                          <option :value="null"></option>
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                        </select>
                      </div>
                      <div
                        class="form-group valid col-md-6 field-textarea"
                        style="float: left"
                      >
                        <label>{{ $t("common.field.companyGroup") }}</label>
                        <select
                          class="form-control"
                          :label="$t('common.field.companyGroup')"
                          :placeholder="$t('common.field.companyGroup')"
                          :disabled="viewMode === 'view'"
                          v-model="currentItem.companyGroupNumber"
                        >
                          <option :value="null"></option>
                          <option :value="1">Saint Denis</option>
                          <option :value="2">Lille</option>
                          <option :value="3">Nantes</option>
                          <option :value="4">Saint-Denis/Lille (Est)</option>
                          <option :value="5">Lyon (Est)</option>
                          <option :value="6">Saint-Etienne</option>
                          <option :value="7">Lyon</option>
                          <option :value="8">Bordeaux</option>
                          <option :value="9">Toulouse</option>
                          <option :value="10">Marseille</option>
                          <option :value="11">Nice</option>
                        </select>
                      </div>
                    </template>
                    <div
                      class="form-group valid col-md-12 field-input"
                      style="float: left"
                    >
                      <label class="control-label" style="margin-bottom: 5px">{{
                        $t("common.field.image")
                      }}</label>
                      <div class="clearfix">
                        <div
                          class="col-md-6"
                          v-if="currentItem.image"
                          style="float: left"
                        >
                          <img
                            style="max-width: 100%"
                            :src="currentItem.image"
                          />
                        </div>
                        <div
                          class="col-md-12"
                          v-if="viewMode === 'edit' || viewMode === 'create'"
                          style="float: left; margin-top: 0; padding-top: 0"
                        >
                          <upload-button
                            name="goodieUrl"
                            :options="{
                              upload: true,
                              targetUrl: 'picture/goodie',
                              method: 'POST',
                              headers: {},
                              base64: false,
                              label: $t('common.buttons.choose'),
                              class: 'btn btn-success',
                            }"
                            @uploaded="uploadDone"
                          ></upload-button>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </slot>
            </div>
            <div class="modal-footer">
              <slot name="edit-modal-footer">
                <button
                  type="button"
                  class="btn btn-default btn-simple mr-auto"
                  @click="closeModal()"
                >
                  {{ $t("common.buttons.cancel") }}
                </button>
                <button
                  type="submit"
                  v-if="viewMode === 'edit'"
                  class="btn btn-primary ml-auto"
                >
                  {{ $t("common.buttons.save") }}
                </button>
                <button
                  type="submit"
                  v-if="viewMode === 'create'"
                  class="btn btn-primary ml-auto"
                >
                  {{ $t("common.buttons.add") }}
                </button>
                <button
                  type="button"
                  v-if="viewMode === 'view'"
                  class="btn btn-primary ml-auto"
                  @click="closeModal()"
                >
                  {{ $t("common.buttons.close") }}
                </button>
              </slot>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2/dist/sweetalert2.js";
import apiErrors from "@/mixins/api-errors";
import EventBus from "@/stores/event-bus";
import config from "@/config/index";

export default {
  components: {},
  data() {
    return {
      url: config.apiUrl.replace("/api", ""),
      viewMode: "view",
      currentItem: {},
      tableNeedsRefresh: false,
      statsNeedsRefresh: false,
      actions: {
        edit: true,
        view: true,
        delete: true,
        export: true,
      },
      table: {
        columns: [
          { field: "_id", type: "number" },
          "title",
          { field: "image", type: "image" },
          "description",
          { field: "stageId", type: "number" },
          { field: "quantity", type: "number"},
          { field: "isActive", type: "number" },
        ],
        data: [],
      },
    };
  },
  mixins: [apiErrors],
  created() {
    this.loadData();
    if (this.$route.params && this.$route.params.id) {
      this.$http
        .get(`goodie/${this.$route.params.id}`)
        .then((res) => {
          if (this.$route.name === "Edit") {
            this.editFunction(res.data.body);
          } else if (this.$route.name === "View") {
            this.viewFunction(res.data.body);
          }
          this.$forceUpdate();
        })
        .catch(this.apiErrorCallback);
    }
  },
  mounted() {
    this.$modal = $("#goodieModal");
  },
  methods: {
    uploadDone(e) {
      if (e && e.body && e.body.url) {
        this.currentItem.image = e.body.url;
        // this.openModal()
      }
    },

    importResponse(e) {
      this.$notifications.clear();
      if (
        (!e.improperData || e.improperData.length === 0) &&
        (!e.properData || e.properData.length === 0)
      ) {
        swal({
          title: this.$t("common.messages.no_data_imported", {
            title: this.name,
          }),
          type: "warning",
        });
        return;
      }

      if (e.properData.length > 0) {
        this.$notify({
          title: this.$t("common.messages.successfullyImported", {
            title: "Goodie",
          }),
          type: "success",
        });
      }

      if (e.improperData.length > 0) {
        let message = "";
        e.improperData.forEach((element) => {
          message += ` - ${Object.values(element).join(" | ")}, `;
        });
        message = message.substring(0, message.length - 2);
        setTimeout(() => {
          this.$notify({
            title: `${e.improperData.length} ${this.$t(
              "common.messages.not_imported",
              { title: "Goodie" }
            )}`,
            message,
            type: "warning",
            timeout: 30000,
          });
        }, 0);
      }

      this.tableNeedsRefresh = true;
      this.statsNeedsRefresh = true;
      this.$forceUpdate();
    },

    loadData() {
      this.$http
        .get("/goodie")
        .then((res) => {
          if (res && res.data && res.data.body) {
            this.table.data = res.data.body;
          }

          this.tableNeedsRefresh = true;
          this.statsNeedsRefresh = true;
          this.$forceUpdate();
        })
        .catch(this.apiErrorCallback);
    },

    openModal() {
      this.$modal.modal("show");
    },

    closeModal() {
      this.$modal.modal("hide");
    },

    gotToEditPage(item) {
      this.$router.push({ path: `/app/goodie/${item._id}/edit` });
      this.editFunction(item);
    },

    gotToViewPage(item) {
      this.$router.push(`/app/goodie/${item._id}`);
      this.viewFunction(item);
    },

    editItem() {
      this.$http
        .put(`/goodie/${this.currentItem._id}`, this.currentItem)
        .then((res) => {
          EventBus.$emit(`${this.name}:created`, res.data);
          swal({
            title: this.$t("common.messages.successfullyModified", {
              title: this.$t("common.labels.goodies"),
            }),
            type: "success",
          });
          this.tableNeedsRefresh = true;
          this.loadData();
          this.$forceUpdate();

          this.closeModal();
        })
        .catch(this.apiErrorCallback);
      return false;
    },

    createItem() {
      this.$http
        .post("/goodie", this.currentItem)
        .then((res) => {
          EventBus.$emit(`${this.name}:created`, res.data);
          swal({
            title: this.$t("common.messages.successfullyCreated", {
              title: this.$t("common.labels.goodies"),
            }),
            type: "success",
          });
          this.tableNeedsRefresh = true;
          this.statsNeedsRefresh = true;
          this.$forceUpdate();

          this.closeModal();
        })
        .catch(this.apiErrorCallback);
      return false;
    },

    editFunction(item) {
      this.viewMode = "edit";
      this.currentItem = item;
      this.openModal();
    },

    viewFunction(item) {
      this.viewMode = "view";
      this.currentItem = item;
      this.openModal();
    },

    createFunction(item) {
      // console.log(item);
      this.viewMode = "create";
      this.currentItem = {
        title: "",
        description: "",
        quantity: 0,
        image: "",
        // isActive: 1
      };
      this.openModal();
    },

    deleteFunction(item) {
      swal({
        title: this.$t("common.messages.are_you_sure"),
        text: this.$t("common.messages.wont_be_able_recover"),
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("common.buttons.yes_delete_it"),
        cancelButtonText: this.$t("common.buttons.cancel"),
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(`/goodie/${item._id}`)
            .then((res) => {
              this.tableNeedsRefresh = true;
              this.statsNeedsRefresh = true;
              this.$forceUpdate();
            })
            .catch((err) => console.error(err));
        }
      });
    },
  },
};
</script>
<style></style>
